import "@/core/i18n";

import { Provider } from "./provider";

export const App = () => {
  return <Provider></Provider>;
};
